import styled from "@emotion/styled";
import type { ReactNode } from "react";

import { Icon, SkiliticsIcon } from "../../icons";
import { FONT_WEIGHT_SEMI_BOLD } from "../../utilities/constants";

const height = `36px`;

const PanelItemContainer = styled.div<{ $draggable: boolean; active?: boolean }>`
  display: grid;
  grid-template-rows: ${height};
  grid-template-columns: ${({ $draggable }) => ($draggable ? "4px 16px auto" : "4px auto")};
  column-gap: 15px;

  width: 100%;

  &:hover {
    background-color: ${({ theme }) => theme.surfaceVariant};
  }

  background-color: ${({ active, theme }) => (active ? theme.primaryContainer : theme.surface)};
`;

const ActiveIndicator = styled.div<{ active: boolean }>`
  width: 4px;
  background-color: ${({ active, theme }) => (active ? theme.primary : "transparent")};
`;

const DragHandle = styled.div`
  display: flex;
  align-items: center;

  width: 100%;

  opacity: 0.65;
`;

export const MainPanelItem = styled.div`
  display: grid;
  grid-template-rows: ${height};
  grid-template-columns: auto 40px;

  align-items: center;
  justify-items: start;

  width: 100%;

  font-size: ${({ theme }) => theme.fontSizeSmall};
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};

  cursor: pointer;

  & i {
    justify-self: center;
  }
`;

type Props = {
  label: ReactNode;
  active?: boolean;
  draggable?: boolean;
  onSelect?: () => void;
};

export const MainPanelDraggableItem = ({ draggable = false, active = false, label, onSelect, ...rest }: Props) => (
  <PanelItemContainer $draggable={draggable} active={active} data-test="item" {...rest}>
    <ActiveIndicator active={active} data-test="active-indicator" />
    {draggable && (
      <DragHandle data-test="drag-handle">
        <SkiliticsIcon icon="drag-grip" />
      </DragHandle>
    )}
    <MainPanelItem onClick={onSelect} data-test="content-container">
      {label}
      <Icon icon="angle-right" size={14} />
    </MainPanelItem>
  </PanelItemContainer>
);
